<template>
  <div class="yishengDetails-box">
    <div class="doctor-hint">
      <div class="doctor-img">
        <img src="~@/assets/images/doctor.png">
      </div>
      <div>
        <div class="name">{{ (list && list.doctorName) || "——" }}</div>
        <van-button type="info">
          <img src="../../assets/images/v_pic.png" alt="" style="width:25%">
          {{ (list && list.titleName) || "——" }}</van-button>
        <div class="dept">出诊科室：{{ (list && list.deptName) || "——" }}</div>
        <!-- <div class="love">专业特长：{{ list.doctorGood || "暂无" }}</div> -->
      </div>
    </div>
    <van-cell-group style="white-space: pre-wrap">
      <van-cell
        :label="list.doctorIntroduce || '暂无'"
        style="margin-top: 10px"
      >
        <template #title>
          <img src="../../assets/images/tuceng.png">
          <span class="custom-title">个人简介</span>
        </template>
      </van-cell>
    </van-cell-group>
    <van-loading v-if="loading" />
  </div>
</template>

<script>
export default {
  name: 'YishengDetails',
  data() {
    return {
      list: {
        doctorName: '',
        titleName: '',
        doctorIntroduce: '',
        doctorGood: ''
      },
      doctorCode: '',
      loading: false
    }
  },
  created() {
    const { doctorCode, deptCode } = this.$route.query
    this.doctorCode = doctorCode
    this.deptCode = deptCode
  },
  mounted() {
    this.$nextTick(function() {
      this.getDoctorKeepList()
    })
  },
  methods: {
    getDoctorKeepList() {
      const parms = {
        deptCode: this.deptCode,
        doctorCode: this.doctorCode
      }
      this.loading = true
      this.$Apis
        .getDoctorInfo(parms)
        .then(res => {
          this.loading = false
          if (res.code === 200) {
            this.list = res.data
          }
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-loading {
  margin-top: 1rem;
  text-align: center;
}
.doctor-hint {
  display: flex;
  background-color: #fff;
  padding: 25px;
  align-items: center;
  box-shadow: 0px 0px 10px rgb(224, 221, 221);
  border-radius: 5px;
  margin: 10px;
  .name {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .dept {
    margin-top: 10px;
    color: #4d4d4d;
    // font-weight: 600;
  }
  .love {
    margin-top: 10px;
    line-height: 22px;
    color: #9d9d9d;
  }
}
/deep/ .van-cell-group {
  box-shadow: 0px 0px 10px rgb(224, 221, 221);
  border-radius: 5px;
  margin: 10px;
  img {
    width: 17px;
    margin-right: 10px;
    box-shadow: 5px 5px 2px rgba(154, 200, 243, 0.5);
  }
}
.doctor-img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  > img {
    width: 50px;
    height: 50px;
  }
}

.van-cell__title {
  color: #1989fa;
  font-size: 18px;
}
.van-cell__label {
  line-height: 26px;
}
.van-icon {
  color: #1989fa;
}
.van-button {
  height: 24px;
  padding: 5px;
  padding-left: 0;
  border-radius: 10px;
}
.van-icon {
  color: white;
}
</style>
